import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
 *  Collection Artist
 *    Scripts to handle the scroll takeover for the artist collection.
 *
 *  Version:
 *    1.0.0 - 2021/10/28
 */

import * as ResponsiveSizes from './../settings/Responsive';
var CONTAINER_SELECTOR = '[data-artist-template]';
var SELECTOR_SCROLL_CONTAINER = '[data-scroll-container]';
var CLASS_INITIALISED = 'is-initialised';
document.querySelectorAll(CONTAINER_SELECTOR).forEach(function (container) {
  var scrollContainer = container.querySelector(SELECTOR_SCROLL_CONTAINER);
  if (!scrollContainer) return;
  var scrollWidth = 0;
  var windowWidth = 0;
  var windowHeight = 0;
  var containerHeight = 0;
  var trackingScroll = false;
  updateElementDimensions();

  /**
   * Event Listeners
   */
  window.addEventListener('resize', updateElementDimensions);

  /**
   * Methods
   */
  function onScroll() {
    var top = document.documentElement.scrollTop;
    var scrollPercent = top / (containerHeight - windowHeight);
    var scrollValue = (scrollWidth - windowWidth) * scrollPercent;
    scrollContainer.scrollLeft = scrollValue;
  }
  function updateElementDimensions() {
    if (window.innerWidth < ResponsiveSizes.medium) return disableScrollListener();
    scrollWidth = scrollContainer.scrollWidth;
    windowWidth = document.documentElement.clientWidth;
    windowHeight = document.documentElement.clientHeight;
    containerHeight = container.offsetHeight;
    disableScrollListener(false);
  }

  /**
   * Removes event listneres if listening, enables if we need to
   * @param {boolean} disable variable to disable or enable onscroll listener
   */
  function disableScrollListener() {
    var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (disable && trackingScroll) {
      window.removeEventListener('scroll', onScroll);
      trackingScroll = false;
    } else if (!disable && !trackingScroll) {
      window.addEventListener('scroll', onScroll);
    }
  }
  container.classList.add(CLASS_INITIALISED);
});